import React from 'react';
import { wdayLogoPrimaryUri, WORKDAY_LOGO } from '@workday/upc-common';

interface WdayLogoProps {
    className?: string;
    alt?: string;
}

export const WdayLogo = ({ className, alt = WORKDAY_LOGO }: WdayLogoProps) => {
    return <img className={className} src={wdayLogoPrimaryUri} alt={alt} />;
};
